import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'isomorphic-fetch';
import './setReactGlobals'; // must run before App so vendor shims see __SAVIYNT_MFE_REACT__ / __SAVIYNT_MFE_REACT_DOM__
import React from 'react';
import { createRoot } from 'react-dom/client';
import './ECMv6/assets/css/global.css';
import IdentitiesVerification from 'ui-home/src/IdentitiesVerification';
import { injectTokens } from '@saviynt/tokens';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SessionTimeout from 'ui-home/src/logout/SessionTimeout';
import { routes as authRoutes } from '@saviynt/auth';
import { App, AppWrapper } from './ui-home/src/App';
import * as serviceWorker from './serviceWorker';
import AppHeader from './ui-home/src/AppHeader';

// eslint-disable-next-line import/prefer-default-export -- needed by webpack
export function initHostApp(hostStore) {
  // Routes added here are available without logging in.
  const appComponent = (
    <AppWrapper>
      <BrowserRouter>
        <Switch>
          {/* Public/unauthenticated MFE routes */}
          <Route path="/ECMv6/forms/public/" render={() => <div id="mfe-container" />} />
          <Route path="/ECMv6/identities/idproofing/request" component={IdentitiesVerification} />
          <Route path="/ECMv6/sessiontimeout" component={SessionTimeout} />
          {authRoutes().map((route) => (
            <Route key={route.path} path={route.path} component={route.Component} />
          ))}
          <Route render={() => <App hostStore={hostStore} />} />
        </Switch>
      </BrowserRouter>
    </AppWrapper>
  );
  const root = createRoot(document.getElementById('root'));
  root.render(appComponent);
}

injectTokens();
serviceWorker.unregister();

if (process.env.REACT_APP_MODE === 'ECM') {
  const headerRoot = createRoot(document.getElementById('header'));
  headerRoot.render(<AppHeader />);
}
